import {Component, HostBinding, Input, OnInit} from "@angular/core";

@Component({
    selector: 'db-tab-content',
    templateUrl: './tab-content.component.html',
    styleUrls: ['./tab-content.component.scss'],
    standalone: false
})
export class TabContentComponent implements OnInit {

  @HostBinding('class.db-tab-content-host_active') public isActive: boolean;

  @Input() tabId: string | string[];
  @Input('activeTabId')
  get activeTabId(): string {
    return this._activeTabId;
  }
  set activeTabId(value: string) {
    this._activeTabId = value;
    this.updateIsActive();
  }

  private _activeTabId: string;

  ngOnInit(): void {
    this.updateIsActive();
  }

  private updateIsActive(): void {
    this.isActive = !this.tabId || this.tabId === this.activeTabId;
  }

}
